"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var TableProposalDetail_1;
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const GISLifeCycleItem_vue_1 = __importDefault(require("./GISLifeCycleItem.vue"));
const LabLifeCycleItem_vue_1 = __importDefault(require("./LabLifeCycleItem.vue"));
const MetadataLifeCycleItem_vue_1 = __importDefault(require("./MetadataLifeCycleItem.vue"));
const ResultsLifeCycleItem_vue_1 = __importDefault(require("./ResultsLifeCycleItem.vue"));
const SampleCollectingLifeCycleItem_vue_1 = __importDefault(require("./SampleCollectingLifeCycleItem.vue"));
const ShipmentLifeCycleItem_vue_1 = __importDefault(require("./ShipmentLifeCycleItem.vue"));
const ZonesLifeCycleItem_vue_1 = __importDefault(require("./ZonesLifeCycleItem.vue"));
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const trans_1 = require("@common/tsutils/trans");
const LifeCycleStage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/LifeCycleStage"));
const ModuleChangePayload_1 = __importDefault(require("@becrop/components/Modules/Common/Models/ModuleChangePayload"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
const ModalChangeModule_vue_1 = __importDefault(require("@becrop/components/Modules/Common/Components/ModalChangeModule.vue"));
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
const GeoEntities_1 = require("../../../../abstract/Models/GeoEntities");
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let TableProposalDetail = TableProposalDetail_1 = class TableProposalDetail extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        //Actions actived
        this.actionShipment = false;
        this.shippingOngoing = false;
        this.shippingResponse = '';
        this.shippingResponseMsg = '';
        this.actionGISCloud = false;
        this.GISCloudOngoing = false;
        this.GISCloudResponse = '';
        this.GISCloudResponseMsg = '';
        this.GISCloudID = '';
        this.is_internal_collector_giscloud = false;
        this.actionMetadata = false;
        this.hookForMetadata = 0;
        this.HZonesOngoing = false;
        this.userHook = 'user';
        this.bmkHook = 'bmk';
        this.pendingHook = 'pending';
        this.selectedAreaId = 0;
        this.hasActiveGISProcess = false;
        this.hasExistingProcess = false;
        this.alreadySharedUserId = '';
        this.hooks = [this.userHook, this.bmkHook, this.pendingHook];
        this.projectSelectId = 0;
        this.areaSelectId = 0;
        this.modules = [
            {
                name: 'Proposals',
                slug: 'proposals',
                url: 'https://proposal.biomemakers.com',
                description: 'Description',
            },
            {
                name: 'Results',
                slug: 'results',
                url: 'https://portal.becrop.com',
                description: 'Description',
            },
            {
                name: 'Tracking',
                slug: 'tracking',
                url: 'https://portal.becrop.com/tracking',
                description: 'Description',
            },
        ];
        this.criteriaArr = [];
        this.eventTracker = new EventTracker_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    getIds(projId, areaId) {
        this.projectSelectId = projId;
        this.areaSelectId = areaId;
    }
    loadResultTimeFinish() {
        const destMod = new Module_1.default({
            name: 'Results',
            slug: 'results',
            url: 'https://portal.becrop.com',
            description: 'Description',
        });
        destMod.switchToThisModule();
        window.location.href =
            '/results/map?projectId=' +
                this.projectSelectId +
                '&areaId=' +
                this.areaSelectId;
    }
    seeResults(projLine) {
        const builtURL = '/results/map?projectId=' + projLine.project_id + '&areaId=' + projLine.area.meta.id;
        const moduleChangePayload = new ModuleChangePayload_1.default({
            'originModule': 'tracking',
            'destinationModule': 'results',
            'url': builtURL
        });
        this.$emit('switchToResults', moduleChangePayload);
    }
    changeGISCloudID(s) {
        this.GISCloudID = s;
    }
    deployActionShipment(id) {
        this.selectedAreaId = id;
        this.actionShipment = true;
    }
    dismissActionShipment() {
        if (this.shippingResponse === 'ok') {
            this.setPhaseAsDone('sample_shipping', this.selectedAreaId);
        }
        this.shippingResponse = '';
        this.shippingResponseMsg = '';
        this.actionShipment = false;
    }
    deployActionMetadata(ix) {
        this.hookForMetadata = ix;
        this.actionMetadata = true;
    }
    dismissActionMetadata() {
        this.actionMetadata = false;
    }
    deployActionGISCloud(id, hasExistingProcess, hasActiveGISProcess, user) {
        this.hasExistingProcess = false;
        this.hasActiveGISProcess = false;
        this.selectedAreaId = id;
        this.hasExistingProcess = hasExistingProcess;
        this.hasActiveGISProcess = hasActiveGISProcess;
        this.actionGISCloud = true;
        this.alreadySharedUserId = user;
    }
    get getTitleActiveExistingGIS() {
        let title = '';
        let user = this.alreadySharedUserId;
        if (user.length === 0)
            user = 'Biomemakers Temporal User';
        if (this.hasExistingProcess) {
            if (this.hasActiveGISProcess) {
                title += (0, trans_1.trans)('tracking.gis_cloud_upload.existing') + ' ' + user;
            }
            else {
                title += (0, trans_1.trans)('tracking.gis_cloud_upload.ongoing');
            }
        }
        return title;
    }
    dismissActionGISCloud() {
        /*
                THIS PREVENTS THE ACTION TO BE SET AS DONE IN THE PROPOSAL STATUS
        
                if (this.GISCloudResponse === 'ok') {
                    this.setPhaseAsDone('sample_collecting', this.selectedAreaId);
                } */
        this.GISCloudResponse = '';
        this.GISCloudResponseMsg = '';
        this.actionGISCloud = false;
    }
    setPhaseAsDone(phaseSlug, areaID) {
        this.$emit('setphaseasdone', phaseSlug, areaID);
    }
    async launchGISCloudFallbackAccount() {
        this.is_internal_collector_giscloud = true;
        await this.shareInGISCloud();
    }
    isOccupacyActive(phase) {
        const userPhases = [
            'gis_file_upload',
            'sample_collecting',
            'metadata',
            'sample_shipping',
        ];
        const bmkPhases = ['calculating_zones', 'lab_quality_control', 'result'];
        if (this.phaseOccupacySelector === this.userHook) {
            if (userPhases.includes(phase))
                return true;
        }
        if (this.phaseOccupacySelector === this.bmkHook) {
            if (bmkPhases.includes(phase))
                return true;
        }
        return false;
    }
    getMyPhase(ix, phaseSlug) {
        const myPhase = this.projectLines[ix].area.life_cycle_area.find((lf) => lf.slug === phaseSlug);
        if (myPhase)
            return myPhase;
        return new LifeCycleStage_1.default({});
    }
    getLabStatus(ix) {
        if (this.projectLines[ix].area.status.slug.includes('lab')) {
            return 'pending';
        }
        else {
            const labReceived = this.projectLines[ix].area.life_cycle_area.find((lf) => lf.slug == 'lab_received');
            if (!labReceived.completed_at) {
                return 'waiting';
            }
            else {
                return 'on_track';
            }
        }
    }
    getMyPhaseStatus(ix, phaseSlug) {
        return this.getMyPhase(ix, phaseSlug).status;
    }
    getMyPhaseDate(ix, phaseSlug) {
        let dateString = this.getMyPhase(ix, phaseSlug).completed_at;
        if (dateString) {
            dateString = this.formattedDate(dateString);
        }
        else {
            dateString = '---';
        }
        return dateString;
    }
    getMyLabPhases(ix) {
        //'lab_received'
        const labSlugs = [
            'lab_received',
            'lab_dna_extraction',
            'lab_pcr',
            'lab_pool',
            'lab_sequenced',
            'lab_quality_control',
        ];
        const labPhases = this.projectLines[ix].area.life_cycle_area.filter((lf) => labSlugs.includes(lf.slug));
        return labPhases;
    }
    formattedDate(s) {
        if (s)
            return this.$filters.formattedDate(s);
        else
            return '-';
    }
    beautifyExtension(s) {
        if (s) {
            return (Math.round((parseFloat(s) + Number.EPSILON) * 100) / 100).toString();
        }
        return '-';
    }
    chooseSortable(c) {
        this.$emit('updateSortable', c);
        let updatedDir = this.direction;
        this.criteriaArr.push(c);
        if (this.criteriaArr.length >= 2) {
            if (this.criteriaArr[0] !== this.criteriaArr[1]) {
                updatedDir = 0;
            }
            this.criteriaArr.shift();
        }
        if (updatedDir === 0) {
            updatedDir = 1;
        }
        else if (updatedDir === 1) {
            updatedDir = -1;
        }
        else if (updatedDir === -1) {
            updatedDir = 0;
        }
        const mixpanelHandler = new MixpanelHandler_1.default();
        mixpanelHandler.trackEvent('proposalsDetailsSorting', {
            criteria: c,
            direction: updatedDir,
        });
    }
    sendEmailCS() {
        let subject = (0, trans_1.trans)('tracking.life_cycles.metadata.email_subject') +
            ' BeCrop ' +
            this.projectLines[this.hookForMetadata].type.toUpperCase() +
            ' - ' +
            this.projectLines[this.hookForMetadata].area.meta.name;
        window.location.href = 'mailto:support@becrop.com?subject=' + subject;
        this.dismissActionMetadata();
    }
    async markAsShipped() {
        this.shippingOngoing = true;
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        try {
            const url = '/tracking/shippings';
            const response = await axios_1.default.post(config.baseURL + url, {
                gis_area_id: this.selectedAreaId,
            });
            this.shippingResponse = 'ok';
            this.shippingResponseMsg = (0, trans_1.trans)('tracking.shipping_resp_ok');
        }
        catch (e) {
            this.shippingResponse = 'err';
            const errorsMsg = [];
            for (const error of e.response.data.error) {
                errorsMsg.push(`${error}`);
            }
            this.shippingResponseMsg = errorsMsg.join(' <br> ');
        }
        this.shippingOngoing = false;
    }
    async shareInGISCloud() {
        this.GISCloudOngoing = true;
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        let data = {
            gis_area_id: this.selectedAreaId,
            share: true,
            user: this.GISCloudID,
            is_internal_collector_giscloud: false
        };
        let idata = {};
        if (this.is_internal_collector_giscloud) {
            idata = {
                gis_area_id: this.selectedAreaId,
                is_internal_collector_giscloud: true
            };
        }
        try {
            const url = '/tracking/giscloud/upload';
            let response;
            if (this.is_internal_collector_giscloud) {
                response = await axios_1.default.post(config.baseURL + url, idata);
            }
            else {
                response = await axios_1.default.post(config.baseURL + url, data);
            }
            this.GISCloudResponse = 'ok';
            const projLineIx = this.projectLines.findIndex((pl) => pl.area.meta.id === this.selectedAreaId);
            this.projectLines[projLineIx].area.meta.giscloud = response.data.giscloud;
            this.hasExistingProcess = true;
            this.alreadySharedUserId = response.data.giscloud.user;
            if (this.is_internal_collector_giscloud) {
                //this.GISCloudResponseMsg = trans('tracking.giscloud_feedback.account_information_temporal');
                this.GISCloudResponseMsg = response.data.message;
            }
            else {
                //this.GISCloudResponseMsg = trans('tracking.shared_resp_ok');
                this.GISCloudResponseMsg = response.data.message;
            }
        }
        catch (e) {
            console.log(e.response);
            // BEWARE: Previously was e.response.data.error[0].message and was failing
            console.log(e.response.data.error[0].message);
            this.GISCloudResponse = 'err';
            const errorsMsg = [];
            for (const error of e.response.data.error) {
                errorsMsg.push(`${error.message}`);
            }
            this.GISCloudResponseMsg = errorsMsg.join(' <br> ');
        }
        this.GISCloudOngoing = false;
        this.is_internal_collector_giscloud = false;
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    async viewZonesInMap(id) {
        this.eventTrackerListener('Calc. Zones', 'Open Calc. Zones');
        this.HZonesOngoing = true;
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        try {
            const area = this.projectLines.find((pr) => pr.area.meta.id === id);
            const url = '/tracking/gis_area/' + id;
            const response = await axios_1.default.get(config.baseURL + url);
            if (response.data.gis_fields.length > 0) {
                area.area.fields = response.data.gis_fields.map((fieldObj) => new GeoEntities_1.Field(fieldObj));
            }
            this.$emit('deploymapzones', response.data, area);
        }
        catch (e) {
            console.log(e.message);
        }
        this.HZonesOngoing = false;
    }
    openViewByMode() {
        if (this.samplingStepStatus === 'sampling') {
            const url = new URL(window.location.href);
            this.selectedAreaId = parseInt(url.searchParams.get('area_id'));
            url.searchParams.delete('area_id');
            window.history.pushState({}, document.title, url);
            this.viewZonesInMap(this.selectedAreaId);
        }
        else if (this.samplingStepStatus === 'refresh') {
            this.viewZonesInMap(this.selectedAreaId);
        }
    }
    jumpToViewZones() {
        // window.location.href = window.location.href + '&area_id=' + this.selectedAreaId + '&sampling=true';
        const href = window.location.href + '&area_id=' + this.selectedAreaId + '&sampling=true';
        const url = new URL(href);
        window.history.pushState({}, document.title, url);
        this.viewZonesInMap(this.selectedAreaId);
    }
    onResetGisArea(id) {
        this.selectedAreaId = id;
        this.$emit('onResetGisArea', id);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TableProposalDetail.prototype, "projectLines", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableProposalDetail.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableProposalDetail.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProposalDetail.prototype, "theadElements", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProposalDetail.prototype, "phaseOccupacySelector", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProposalDetail.prototype, "textSearch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], TableProposalDetail.prototype, "criteria", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableProposalDetail.prototype, "pendingAssociationQuotes", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'default' })
], TableProposalDetail.prototype, "samplingStepStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableProposalDetail.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('samplingStepStatus')
], TableProposalDetail.prototype, "openViewByMode", null);
TableProposalDetail = TableProposalDetail_1 = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            LifeCycleAreaItem: bmk_ui_framework_1.LifeCycleAreaItem,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            CrossIcon: bmk_ui_framework_1.CrossIcon,
            TableProposalDetail,
            GISLifeCycleItem: GISLifeCycleItem_vue_1.default,
            LabLifeCycleItem: LabLifeCycleItem_vue_1.default,
            MetadataLifeCycleItem: MetadataLifeCycleItem_vue_1.default,
            ResultsLifeCycleItem: ResultsLifeCycleItem_vue_1.default,
            SampleCollectingLifeCycleItem: SampleCollectingLifeCycleItem_vue_1.default,
            ShipmentLifeCycleItem: ShipmentLifeCycleItem_vue_1.default,
            ZonesLifeCycleItem: ZonesLifeCycleItem_vue_1.default,
            Modal: bmk_ui_framework_1.Modal,
            ShipmentIcon: bmk_ui_framework_1.ShipmentIcon,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            Button: bmk_ui_framework_1.Button,
            Link: bmk_ui_framework_1.Link,
            InputField: bmk_ui_framework_1.InputField,
            Toasts: bmk_ui_framework_1.Toasts,
            Dropdown: floating_vue_1.Dropdown,
            Mail: lucide_vue_next_1.Mail,
            ModalChangeModule: ModalChangeModule_vue_1.default,
        },
    })
], TableProposalDetail);
exports.default = TableProposalDetail;
